<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div class="header-color" style="display: flex; flex-direction: row;">
            <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Calendar</span>
            </div>
            <div style="display: flex; flex-direction: row; padding: 5px">
                <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; justify-content: center">
                    <button mat-stroked-button class="mat-card-button" (click)="calendarClick()" [disabled]="card.disabled"><span translate>Go To Calendar</span></button>
                </div>
            </div>
        </div>
        <div style="padding: 10px;display: flex;flex: 1; justify-content: center">
            <div style="display: flex;flex: 1;justify-content: center;flex-direction: column;max-width: 330px;">
                <tyl-cal-widget (monthChange)="monthChange($event)" (dayClick)="dayClick($event)" [nonAttendanceDates]="nonAttendanceDates" [eventDates]="eventDates" date=""></tyl-cal-widget>
            </div>
        </div>
    </div>
</mat-card>
